import React from "react";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Tomos } from "./components/Tomos";
import { Bonos } from "./components/Bonos";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { About } from "./components/About";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full bg-[var(--cream)] text-gray-900" data-id="element-0" data-mp="28ufp6dtutik4">
      <main className="w-full" data-id="element-1" data-mp="28suw6sn6u7od">
        <Hero data-id="element-2" data-mp="28s30zixi6bym" />
        <Stats data-id="element-3" data-mp="23vkuoemiy5k6" />
        <BeforeAfter data-id="element-4" data-mp="23w4g45bdvc2y" />
        <PainPoints data-id="element-5" data-mp="23ujl6el5pr4k" />
        <Tomos data-id="element-6" data-mp="23t8heerpojdg" />
        <Bonos data-id="element-7" data-mp="23ti5txx3yih1" />
        <Offer data-id="element-8" data-mp="3ik7ekc2063oj" />
        <Guarantee data-id="element-9" data-mp="3ikqyfyb7r257" />
        <Testimonials data-id="element-10" data-mp="3ij65ue8glt9z" />
        <About data-id="element-11" data-mp="3ihv22ef0kliv" />
        <FAQ data-id="element-12" data-mp="3ii4ppvcl6gle" />
        <FinalCTA data-id="element-13" data-mp="3mlayb9n68jv1" />
        <Footer data-id="element-14" data-mp="3mkrchhuehbbq" />
      </main>

      {/* Floating CTA appears after scrolling past the hero button */}
      <FloatingCTA triggerId="hero-cta" data-id="element-15" data-mp="3rdaqgfx028h2" />

      {/* Social-proof purchase notifications */}
      <PurchasePopup data-id="element-16" data-mp="680tswt8a8y" />
    </div>;
}